import { useSelector } from "react-redux"
import { AppState } from "../state/app"

export const useIsLoggedIn = (): boolean | null => {
    const { isLoggedIn } = useSelector( ( state: AppState ) => state.app )
    return isLoggedIn
}
